import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'datum'
})
export class MyDatumPipe implements PipeTransform
{
  transform(datum: string): string
  {
    if (!datum) return "";
    let d = new Date(datum);
    return d.toLocaleDateString();
  }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/mydatum.pipe.ts